angular.module('impactx.catalog').controller('CatalogRuleCheckErrorCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    CatalogRuleCheckErrorCtrl]);

function CatalogRuleCheckErrorCtrl($scope, dataGen, $mdDialog) {
    var self = this;

    dataGen.getData($scope, {cmrliId: self.cmrliId, catId: self.catId}, "/catalog/rulecheckerror");

    self.cancel = function () {
        $mdDialog.cancel();
    };
}